import { ZoneNatureLevelType } from "src/app/model";

export interface ZoneOrderPayloadModel {
  siteId: string;
  attributes: string[];
}

export interface ZoneOrderModel {
  order: number;
  natureDescription: string;
  nature: ZoneNatureLevelType;
}